import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { ClaimStatus } from 'src/app/core/enums/claim-status.enum';
import { GetDepartmentsUseCase } from 'src/app/core/services/location/domain/usecases/get-departments.usecase';
import { Failure } from 'src/app/core/utils/failure';
import { UserData } from 'src/app/features/user/domain/entities/user-data.entity';
import { GetAllConciliatorsUseCase } from 'src/app/features/user/domain/usecases/get-all-conciliators.usecase';
import { Departament } from 'src/app/features/user/presentation/components/New-User-SuperAdmin/newUser.component';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import { ClaimFilterModel } from 'src/app/features/claims/data/models/claim-filter.model';
import { FilterServiceService } from 'src/app/features/claims/services/filter-service.service';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-claim-filter',
  templateUrl: './claim-filter.component.html',
  styleUrls: ['./claim-filter.component.css'],
})
export class ClaimFilterComponent implements OnInit {
  @Input() viewStatus: boolean = true;

  stateList: string[] = Object.values(ClaimStatus).filter(
    (status) => status !== ClaimStatus.DRAFT
  );

  departmentList: Departament[] = [];
  conciliatorList: any[] = [];

  selectedStates: string[] = [];
  selectedDate?: Date;
  selectedDepartment?: string;
  selectedconciliator?: string;
  userId?: string;
  generalFilter: string = '';

  statusOrder!: number | null;
  dateOrder!: number | null;
  conciliatorOrder!: number | null;
  departamentOrder!: number | null;
  claimNumberOrder!: number | null;

  private AES = new AESEncryptDecryptService();

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() filters: EventEmitter<ClaimFilterModel> =
    new EventEmitter<ClaimFilterModel>();
  @Input() filterKey: string = 'default';

  @ViewChild('op') overlayPanel!: OverlayPanel;
  private manualClose = false;

  constructor(
    private getAllDepartments: GetDepartmentsUseCase,
    private getAllConciliators: GetAllConciliatorsUseCase,
    private messageService: MessageService,
    private localStorageService: LocalStorageServiceBase,
    private filterService: FilterServiceService
  ) { }

  ngOnInit(): void {
    this.userId = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_rol')
    );
    this.getDepartments();
    if (
      this.userId !== 'Trabajador' &&
      this.userId !== 'Empleador' &&
      this.userId !== 'Conciliador'
    ) {
      this.getConciliators();
    }
    const savedFilters = this.filterService.getFilters(this.filterKey);
    if (savedFilters) {
      this.selectedconciliator = savedFilters.conciliatorId || '';
      this.selectedDepartment = savedFilters.departmentId || '';
      this.selectedDate = savedFilters.fromDate || undefined;
      this.selectedStates = savedFilters.states || [];
      this.generalFilter = savedFilters.generalFilters || '';
      this.statusOrder = savedFilters.statusOrder || null;
      this.dateOrder = savedFilters.dateOrder || null;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterKey'] && changes['filterKey'].currentValue) {
      const savedFilters = this.filterService.getFilters(this.filterKey);
      if (savedFilters) {
        this.selectedconciliator = savedFilters.conciliatorId || '';
        this.selectedDepartment = savedFilters.departmentId || '';
        this.selectedDate = savedFilters.fromDate || undefined;
        this.selectedStates = savedFilters.states || [];
        this.generalFilter = savedFilters.generalFilters || '';
        this.statusOrder = savedFilters.statusOrder || null;
        this.dateOrder = savedFilters.dateOrder || null;
        this.claimNumberOrder = savedFilters.claimNumberOrder || null;
      } else {
        this.cleanFilter();
      }
    }
  }

  async getDepartments(): Promise<void> {
    const result: Departament[] | Failure =
      await this.getAllDepartments.execute();

    if (Array.isArray(result)) {
      this.departmentList = result;
    } else {
      this.errorMessage('error', 'Departamentos');
    }
  }

  async getConciliators(): Promise<void> {
    const result: UserData[] | Failure =
      await this.getAllConciliators.execute();

    if (Array.isArray(result)) {
      this.conciliatorList = result;
      let conciliatorAdd = {
        id: 'No asignado',
        rol: '',
        name: 'No asignado',
        lastName: '',
        cuil: '',
        gender: '',
        phone: '',
        birthDate: new Date(),
        civilStatus: '',
        province: '',
        city: '',
        street: '',
        number: '',
        floorApartment: '',
        postalCode: 0,
        company: '',
        companyCuil: '',
        email: '',
        dni: '',
        neighborhood: '',
      };
      this.conciliatorList = [conciliatorAdd, ...result];
    } else {
      this.errorMessage('error', 'Conciliadores');
    }
  }

  private errorMessage(severity: string, name: string): void {
    this.messageService.add({
      severity: severity,
      summary: name,
      detail: `No se pudieron recuperar los ${name.toLocaleLowerCase()}`,
    });
  }

  orderSelect(typeOrder: string, order: number) {
    const current = this.getCurrentOrder(typeOrder);
    if (current === order) {
      this.clearAllOrders();
    } else {
      this.clearAllOrders();
      this.setOrder(typeOrder, order);
    }
  }

  clearAllOrders(): void {
    this.statusOrder = null;
    this.dateOrder = null;
    this.conciliatorOrder = null;
    this.departamentOrder = null;
    this.claimNumberOrder = null;
  }

  getCurrentOrder(type: string): number | null {
    switch (type) {
      case 'status':
        return this.statusOrder;
      case 'date':
        return this.dateOrder;
      case 'conciliator':
        return this.conciliatorOrder;
      case 'departament':
        return this.departamentOrder;
      case 'claimNumber':
        return this.claimNumberOrder;
      default:
        return null;
    }
  }

  setOrder(type: string, value: number | null): void {
    switch (type) {
      case 'status':
        this.selectedStates = [];
        this.statusOrder = value;
        break;
      case 'date':
        this.selectedDate = undefined;
        this.dateOrder = value;
        break;
      case 'conciliator':
        this.selectedconciliator = undefined;
        this.conciliatorOrder = value;
        break;
      case 'departament':
        this.selectedDepartment = undefined;
        this.departamentOrder = value;
        break;
      case 'claimNumber':
        this.claimNumberOrder = value;
        break;
    }
  }

  hasFilters(): boolean {
    return (
      !!this.generalFilter ||
      !!this.selectedDate ||
      !!this.selectedDepartment ||
      !!this.selectedconciliator ||
      (this.selectedStates && this.selectedStates.length > 0) ||
      !!this.statusOrder ||
      !!this.dateOrder ||
      !!this.conciliatorOrder ||
      !!this.departamentOrder ||
      !!this.claimNumberOrder
    );
  }

  cleanFilter(): void {
    this.selectedconciliator = undefined;
    this.selectedDepartment = undefined;
    this.selectedDate = undefined;
    this.selectedStates = [];
    this.generalFilter = '';
    this.clearAllOrders();
    this.filterService.clear(this.filterKey);
    this.cancel.emit();
    this.overlayPanel.hide();
  }

  applyFilters(): void {
    this.filters.emit({
      conciliatorId: this.selectedconciliator,
      departmentId: this.selectedDepartment,
      fromDate: this.selectedDate,
      states: this.selectedStates,
      generalFilters: this.generalFilter,
      statusOrder: this.statusOrder,
      dateOrder: this.dateOrder,
      conciliatorOrder: this.conciliatorOrder,
      departamentOrder: this.departamentOrder,
      claimNumberOrder: this.claimNumberOrder,
    });
    this.manualClose = true;
    this.overlayPanel.hide();
  }
}
